import AuthRepository from './auth'

import UserRepository from './user'
import RailwayRepository from './railway'
import MeasurementRepository from './measurement'
import ReportRepository from './report'
import UserPermissionRepository from './user_permission'


import PermissionRepository from './permission'
import ContentTypeRepository from './content_type'
import SearchRepository from './search'
import InfrastructureRepository from './infrastructure'



const repositories = {
    auth: AuthRepository,

    UserRepository,
    RailwayRepository,
    MeasurementRepository,
    ReportRepository,
    UserPermissionRepository,

    InfrastructureRepository,
    SearchRepository,
    PermissionRepository,
    ContentTypeRepository,
};

export const RepositoryFactory = {
    get: name => repositories[name]
};
